/* src/app/support/shell/shell.component.css */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}
.full-height-flex {
  flex: 1 1 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.full-height-flex-container-row {
  flex: 1 1 0;
  min-height: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  align-content: flex-start;
  gap: 16px;
  height: 100%;
  box-sizing: border-box;
}
.full-height-flex-container-row .row {
  flex: 1 1 100%;
  min-width: 0;
}
.flex-grow {
  flex: 1 1 auto;
}
::ng-deep mat-tab-group,
.mat-mdc-tab-body-wrapper,
.mat-mdc-tab-body,
.mat-mdc-tab-body-content {
  flex: 1 1 0 !important;
  min-height: 0 !important;
  height: 100% !important;
  display: flex !important;
  flex-direction: column !important;
  overflow: hidden !important;
}
::ng-deep .mat-mdc-tab-body-content {
  height: 100% !important;
  flex: 1 1 0 !important;
  min-height: 0 !important;
  display: flex !important;
  flex-direction: column !important;
  overflow: hidden !important;
}
::ng-deep .mat-mdc-tab-body-wrapper {
  height: 100% !important;
  flex: 1 1 0 !important;
  min-height: 0 !important;
  display: flex !important;
  flex-direction: column !important;
  overflow: hidden !important;
}
textarea {
  flex: 1 1 auto;
  width: 100%;
  min-height: 0;
  height: 100%;
  font-family:
    "Fira Mono",
    "Consolas",
    monospace;
  font-size: 1rem;
  padding: 10px;
  border: 1px solid #222;
  border-radius: 6px;
  background: #181818;
  color: #00ff41;
  resize: vertical;
  margin-bottom: 16px;
  box-sizing: border-box;
  text-shadow: 0 0 2px #00ff41, 0 0 8px #00ff4180;
  letter-spacing: 1px;
  scrollbar-color: #888 #181818;
}
::ng-deep .mat-menu-item {
  background: #fff !important;
  color: #333 !important;
}
::ng-deep .mat-menu-item:hover {
  background: #1976d2 !important;
  color: #fff !important;
}
.dialog-content {
  padding: 32px;
  box-sizing: border-box;
  flex: 1 1 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.shell-root,
.full-height-flex,
.terminal-actions {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.terminal-actions {
  flex: 1 1 0;
  min-height: 0;
  background-color: black;
  padding-bottom: 15px;
}
.terminal-full,
ng-terminal {
  flex: 1 1 0;
  min-height: 0;
  width: 100%;
  height: 100%;
  display: block;
}
.shell-root ::-webkit-scrollbar {
  width: 12px;
  background: #222;
}
.shell-root ::-webkit-scrollbar-thumb {
  background: #444;
  border-radius: 6px;
}
.shell-root ::-webkit-scrollbar-thumb:hover {
  background: #666;
}
.shell-root {
  scrollbar-color: #444 #222;
  scrollbar-width: thin;
}
.program-menu-bar,
.shell-menu-bar,
.popup-row.top-row {
  display: flex;
  align-items: center;
  gap: 16px;
  background: #f5f5f5;
  padding: 0 12px;
  border-bottom: 1px solid #ddd;
  min-height: 40px;
}
.program-menu-bar .popup-title,
.shell-menu-bar .popup-title {
  font-size: 20px;
  font-weight: 500;
  margin-right: 32px;
  margin-bottom: 0;
  white-space: nowrap;
}
.program-menu-bar button[mat-button],
.shell-menu-bar button[mat-button],
.popup-row.top-row button[mat-button] {
  min-width: 60px;
  font-size: 15px;
  font-weight: 400;
  text-transform: none;
  background: transparent !important;
  color: #222 !important;
  box-shadow: none !important;
}
.copy-ssh-command {
  cursor: pointer;
  color: #1976d2;
  text-decoration: underline;
  padding-top: 2px;
}
.ip-text {
  font-size: 14px;
  color: #888;
  padding-top: 2px;
}
.copy-ssh-command:hover {
  color: #1565c0;
}
.active {
  font-weight: 600;
  color: #1976d2 !important;
}
.inactive {
  font-weight: 400;
  color: #660303 !important;
}
.program-menu-bar button[mat-button]:hover,
.shell-menu-bar button[mat-button]:hover,
.popup-row.top-row button[mat-button]:hover {
  background: #e0e0e0 !important;
}
.mat-menu-content button[mat-menu-item] {
  background: transparent !important;
  color: #222 !important;
  box-shadow: none !important;
}
::ng-deep .mat-menu-content button[mat-menu-item]:hover,
::ng-deep .mat-menu-content button[mat-menu-item].cdk-focused,
::ng-deep .mat-menu-content button[mat-menu-item].cdk-program-focused {
  background: #e0e0e0 !important;
  color: #222 !important;
}
/*# sourceMappingURL=shell.component.css.map */
